import { LoaderFunctionArgs } from "react-router-dom";
import { Api } from "../api/Api";
import { ChicagoAbandonedVehicle } from "../api/Application";

export async function chicagoLoader( { params }: LoaderFunctionArgs ): Promise<ChicagoAbandonedVehicle[]> {    
    const result = await Api.abandonedVehicleChicago();
    if( !result.isOk ) {
        throw new Error( result.error || "Failed to fetch abandoned vehicles." );
    }
    return result.value;
}